/**
 @license
 Copyright (c) 2015-2026 Lablup Inc. All rights reserved.
 */
import de_DE from 'backend.ai-ui/dist/locale/de_DE';
import el_GR from 'backend.ai-ui/dist/locale/el_GR';
import en_US from 'backend.ai-ui/dist/locale/en_US';
import es_ES from 'backend.ai-ui/dist/locale/es_ES';
import fi_FI from 'backend.ai-ui/dist/locale/fi_FI';
import fr_FR from 'backend.ai-ui/dist/locale/fr_FR';
import id_ID from 'backend.ai-ui/dist/locale/id_ID';
import it_IT from 'backend.ai-ui/dist/locale/it_IT';
import ja_JP from 'backend.ai-ui/dist/locale/ja_JP';
import ko_KR from 'backend.ai-ui/dist/locale/ko_KR';
import mn_MN from 'backend.ai-ui/dist/locale/mn_MN';
import ms_MY from 'backend.ai-ui/dist/locale/ms_MY';
import pl_PL from 'backend.ai-ui/dist/locale/pl_PL';
import pt_BR from 'backend.ai-ui/dist/locale/pt_BR';
import pt_PT from 'backend.ai-ui/dist/locale/pt_PT';
import ru_RU from 'backend.ai-ui/dist/locale/ru_RU';
import th_TH from 'backend.ai-ui/dist/locale/th_TH';
import tr_TR from 'backend.ai-ui/dist/locale/tr_TR';
import vi_VN from 'backend.ai-ui/dist/locale/vi_VN';
import zh_CN from 'backend.ai-ui/dist/locale/zh_CN';
import zh_TW from 'backend.ai-ui/dist/locale/zh_TW';

// languages which are supported by backend.ai-ui
export const buiLanguages = {
  de: de_DE,
  el: el_GR,
  en: en_US,
  es: es_ES,
  fi: fi_FI,
  fr: fr_FR,
  id: id_ID,
  it: it_IT,
  ja: ja_JP,
  ko: ko_KR,
  mn: mn_MN,
  ms: ms_MY,
  pl: pl_PL,
  'pt-BR': pt_BR,
  pt: pt_PT,
  ru: ru_RU,
  th: th_TH,
  tr: tr_TR,
  vi: vi_VN,
  'zh-CN': zh_CN,
  'zh-TW': zh_TW,
};
